<template>
	<section class="container-unit" :id="[index]">
		<div class="container">
			<h2>{{ unitData.config.title }}</h2>
			<template v-for="(name, index2) in unitData.config.tableBody" :key="index2">
				<div class="unitList" >
					<div class="row">
					<template v-for="(name2, index3) in unitData.config.tableBody[index2]" :key="index3">
						<div class="col-xl-4  col-md-6 table-column" v-if="name2 !== '' && name2 !== 'Nein' && name2 !=='keine Angabe' && name2 != '-'">
							<div class="row">
							<template v-for="(name3, index4) in unitData.config.tableHeader" :key="index4">
								<div class="col-6 table-header" v-if="index4 == index3">
								<span>{{ name3 }}</span>
								</div>
							</template>
		
							<div class="col-6 table-body">
								<div class="icon_checkmark" v-if="name2 == 'Ja'">
								<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 50 50" xml:space="preserve" data-v-0193ec1d=""><path id="Pfad_3373" class="st0" d="M2.5,14.7l13.6,13.6L42.5,2.8" data-v-0193ec1d=""></path></svg>
								</div>
								<div v-else><span>{{ name2 }}</span></div>
							</div>
							</div>
						</div>
					</template>
				</div>
          </div>
        </template>
		</div>
	</section>
</template>

<script>
export default {
	props: {
		unitData: {
			type: Object
		},
		index: {
			type: Number
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-wien/unitListComponent.scss";
</style>
